<script setup>
/******************************************************************************
 * PageComponent: ReadingReqCustomer
 *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
import { useReadingStore } from "Stores/reading";
const props = defineProps({
    customerId: { type: String, required: true },
});
const readingStore = useReadingStore();
const customer = readingStore.customers.find(
    (customer) => customer.customerId === props.customerId
);
</script>

<template>
    <div class="thanks">
        <svg-icon name="done" :size="1" />
        Sie erhalten Ihre Ableseaufforderung in Zukunft per E-Mail an
        {{ customer.newEmail }}.
    </div>
</template>

<style lang="scss" scoped>
.thanks {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: #{get($sizes, "base") * 0.2} #{get($sizes, "base") * 0.2};
    border: get($sizes, "border") solid palette("state", "success");
    margin-top: get($sizes, "base");
    gap: #{get($sizes, "base") * 0.2};

    background-color: color.adjust(
        palette("state", "success"),
        $lightness: +65%
    );
    color: palette("state", "success");

    font-weight: 500;
    text-align: center;
}
</style>
